<template>
    <div>
        <div class="pt-4 topHeader">
            <a href="./">
                <img src="../assets/Logo-APAYM-Cabine.jpg" alt="Logo APaym Cabine" width="200">
            </a> 
        </div>
    </div>
</template>

<script>


    export default {
        components:{
        },
        data() {
            return {
            }
        },
        watch: {
        },
        methods: {
        },

        mounted() { 
        },
    }
</script>

<style scoped>

    .topHeader {
        display: flex;
        align-items: center;
        /* justify-content: space-between; */
        justify-content: center;
        margin-bottom: -25px;
    }

    @media screen and (max-width: 540px){
        .topHeader {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
        }
    }

</style>